import {
  DASHBOARD_CLIENT_LINKS,
  DASHBOARD_COMMON_LINKS,
  DASHBOARD_STORAGE_PROVIDER_LINKS,
} from 'constants/dashboard';
import { ROUTES } from 'constants/routes';
import { useMergedStyles } from 'hooks/useMergedStyles';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useUserContext } from 'state/contexts/userContext/userContext';
import { Styles } from 'types/styles';
import DashboardPageWrapperNavigationLink from './DashboardPageWrapperNavigationLink/DashboardPageWrapperNavigationLink';

import styles from './DashboardPageWrapperNavigation.module.scss';

type Props = {
  newStyles?: Styles;
};

const DashboardPageWrapperNavigation: FC<Props> = ({ newStyles = {} }) => {
  const mergedStyles = useMergedStyles(styles, newStyles);
  const { dashboardLinks } = useDashboardLinks();
  const router = useRouter();

  if (ROUTES.DASHBOARD.INDEX === router.pathname) return null;

  return (
    <div className={mergedStyles['dashboard-page-wrapper-navigation-wrapper']}>
      <div className={mergedStyles['dashboard-page-wrapper-navigation-links-wrapper']}>
        <div
          className={mergedStyles['dashboard-page-wrapper-navigation-links-container']}
        >
          {dashboardLinks.map((data) => (
            <DashboardPageWrapperNavigationLink
              newStyles={mergedStyles}
              key={data.route}
              isActive={router.route.includes(data.route)}
              {...data}
            />
          ))}
        </div>
        <div
          className={mergedStyles['dashboard-page-wrapper-navigation-links-container']}
        >
          {DASHBOARD_COMMON_LINKS.map((data) => (
            <DashboardPageWrapperNavigationLink
              newStyles={mergedStyles}
              key={data.route}
              targetBlank={data.label !== 'howTo'}
              isActive={
                data.label === 'howTo' &&
                router.route.includes(data.route.replace('/store', ''))
              }
              {...data}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardPageWrapperNavigation;

function useDashboardLinks() {
  const {
    user: { isStorageProvider },
  } = useUserContext();

  const getDashboardLinks = () =>
    isStorageProvider ? DASHBOARD_STORAGE_PROVIDER_LINKS : DASHBOARD_CLIENT_LINKS;

  const dashboardLinks = getDashboardLinks();

  return { dashboardLinks };
}
